export const clamp = (value: number, min: number, max: number): number => {
  return Math.min(Math.max(value, min), max);
};

/**
 * Rounds `value` up to the next multiple of `step`, leaving it alone when it is
 * already a multiple.
 *
 * Used for the price filter's dynamic maximum, where the highest result price is
 * rounded up to the nearest $100 so the histogram spans the results rather than a
 * fixed ceiling. Prices there are in cents, so `step` is the cent value of the
 * increment.
 *
 * Guards against a non-positive or non-finite `step`, which would otherwise return
 * Infinity or NaN and quietly break whatever consumes the result.
 */
export const roundUpToNearest = (value: number, step: number): number => {
  if (!Number.isFinite(value) || !Number.isFinite(step) || step <= 0) {
    return value;
  }

  return Math.ceil(value / step) * step;
};
